import axios from 'axios';
import config from '../config/config';
import { clearToken, getToken } from './auth';

export const AUTH_EXPIRED_EVENT = 'khuleg:auth-expired';

const api = axios.create({
  baseURL: config.apiBaseUrl
});

api.interceptors.request.use((request) => {
  const token = getToken();

  if (token) {
    request.headers.Authorization = `Bearer ${token}`;
  }

  return request;
});

api.interceptors.response.use(
  (response) => response,
  (error) => {
    const status = Number(error?.response?.status || 0);
    if (status === 401 && getToken()) {
      clearToken();
      if (typeof window !== 'undefined') {
        window.dispatchEvent(new CustomEvent(AUTH_EXPIRED_EVENT));
      }
    }

    return Promise.reject(error);
  }
);

export default api;
